<template>
  <!-- <v-container class="mt-3"> -->
  <v-card class="border-none rounded-lg px-3 shadow-sm card-reward" no-body>
    <div class="rounded-lg p-3 overflow-hidden contant-reward">
      <div class="text-center">
        <b class="f-xl" data-lang="mission_random_reward_title">{{
          `${
            mission
              ? $t("mission_random_reward_title")
              : $t("random_reward_title")
          }`
        }}</b>

        <div class="text-gray mt-2">
          <small>{{
            getRewardList[count] && getRewardList[count].redeem_code
          }}</small>
        </div>
      </div>
      <lottie-player
        autoplay
        :loop="true"
        mode="normal"
        background="transparent"
        direction="1"
        class="box-animation"
        src="https://lottie.host/24a51c54-51a7-44dc-80da-8d6b46e6dc48/1CMGhFJWGN.json"
        style="width: 100%; height: 300px"
      ></lottie-player>
      <!-- <div class="opened-box">
        <c-img
          :src="require('@/assets/images/thaniya_reward.gif')"
          @error="handleImageSrc"
          class="image-reward"
        ></c-img>
      </div> -->

      <p
        class="text-center mt-3 f-md"
        id="previewMessage"
        data-lang="mission_random_reward_description"
      >
        {{
          mission
            ? $t("mission_random_reward_description")
            : $t("random_reward_description")
        }}
      </p>
      <div class="text-center">
        <c-btn
          pill
          variant="confirm-primary"
          class="shadow-box mb-2 mt-0 btn-open-box"
          @click="$emit('next')"
          data-test="step1-open-box-btn"
          data-lang="open_box"
        >
          {{ $t("open_box") }}
        </c-btn>

        <div
          class="text-gray cursor-pointer"
          v-if="countList.length - (count + 1) != 0"
          @click="$emit('openAll')"
          data-test="step1-open-all-box-btn"
        >
          <small data-lang="open_all_box">
            <u>{{ $t("open_all_box") }} ({{ countList.length - count }})</u>
          </small>
        </div>
        <div style="height: 24px" v-else></div>
      </div>
    </div>
  </v-card>

  <!-- </v-container> -->
</template>

<script>
require("@lottiefiles/lottie-player");
// import * as LottiePlayer from "@dotlottie/player-component";
const box = require("@/assets/images/box3-f.gif");
const boxF = require("@/assets/images/box3-f2.gif");
var timeout = null;
export default {
  // components: {
  //   LottiePlayer
  // },
  props: {
    countList: { required: true },
    getRewardList: { required: true },
    count: { required: true },
    mission: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    rewardImage(items) {
      if (items) {
        if (items.random_reward_item_type == 4)
          return require("@/assets/images/point.png");
        if (items.random_reward_item_type == 1)
          return require("@/assets/images/Fail.png");
        if (items.item_img) return items.item_img;
        return require("@/assets/images/default-image.png");
      }
      return require("@/assets/images/default-image.png");
    }
  }
};
</script>
